<template>
  <div id="app" class="App animated fadeIn">
    <TheMaskWindow @click="closeRechargesApp"/>
    <TheAppContainer>
      <TheHeader />
      <router-view v-bind="globalProps" />
    </TheAppContainer>
  </div>
</template>

<script>
import AppService from '@/services/AppService';
import TheAppContainer from '@/components/Common/TheAppContainer';
import TheHeader from '@/components/Common/TheHeader';
import TheMaskWindow from '@/components/Common/TheMaskWindow';

export default {
  name: 'app',

  components: { TheAppContainer, TheHeader, TheMaskWindow },

  data() {
    return {
      settings: {},
    };
  },

  async mounted() {
    this.settings = await AppService.getRechargesSettings();
  },

  computed: {
    globalProps() {
      return {
        settings: this.settings,
      };
    },
  },

  methods: {
    closeRechargesApp() {
      AppService.closeApp();
    },
  },
};
</script>

<style lang="sass" scoped>
.App
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
</style>
